import { NgModule } from '@angular/core';

import { CloudinaryModule } from '@cloudinary/ng';
import { Cloudinary } from '@cloudinary/url-gen';

import { AvatarUrlPipe } from './avatar-url.pipe';
import { SeoImageUrlPipe } from './seo-image-url.pipe';

@NgModule({
  declarations: [SeoImageUrlPipe, AvatarUrlPipe],
  imports: [CloudinaryModule],
  providers: [
    {
      provide: Cloudinary,
      useFactory: (): Cloudinary => new Cloudinary({ cloud: { cloudName: 'placeme-api' } }),
    },
    SeoImageUrlPipe,
    AvatarUrlPipe,
  ],
  exports: [SeoImageUrlPipe, AvatarUrlPipe],
})
export class CloudinaryUrlModule {}
